import {Component, Input, OnInit} from '@angular/core';
import {ContentService} from '../service/content.service';
import {ContentInfo} from '../model/content-info';
import {MessageService} from '../service/message.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent implements OnInit {

  constructor(private messageService: MessageService,
              private contentService: ContentService,
  ) {
  }

  file: File
  loadedFile: ContentInfo;
  files: ContentInfo[];
  loading: boolean = false;
  @Input() acceptedType: string;
  @Input() maxSize: number;

  ngOnInit() {
    this.contentService.list(this.acceptedType.split("/")[0]).subscribe(
      value => this.files = value
    );
  }

  onFileChange(fileList: FileList) {
    if (fileList && fileList.length == 1) {
      this.file = fileList.item(0);
    }
  }

  onSubmit(): void {
    if (this.file) {
      let formData: FormData = new FormData();
      formData.append("file", this.file.slice(0, this.file.size, this.file.type), this.file.name);
      if (this.file.size > this.maxSize * 1048576) {
        this.messageService.addDefaultError(`You have exceeded the maximum allowable file size (${this.maxSize} mb).`);
        return;
      }
      this.loading = true;
      this.contentService.upload(formData)
        .subscribe(
          v => {
            this.loadedFile = v;
            this.files.push(this.loadedFile);
          },
          err => this.messageService.addDefaultError(err)
        );
      this.loading = false;
      this.file = null;
    }
  }

  getAcceptedType(): string {
    return this.acceptedType;
  }

  onDelete(file: ContentInfo): void {
    this.contentService.delete(file.id).subscribe(
      value => {
        let idx = this.files.indexOf(file);
        this.files.splice(idx, 1);
      }, err => this.messageService.addDefaultError(err)
    )
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/upload-file/upload-file.component.ts